module.exports = __webpack_public_path__ + "static/media/map-pin.0672dc5c.svg";